import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import FormattedCurrencyContainer from '../../../../../../components/formatted-currency/container';
import messages from '../../messages';
import { getDeliveryTimeStringFromRate } from './get-delivery-time-string-from-rate';
import style from './preview-modal.module.less';
import { RateStatusIndicator } from './rate-status-indicator';

export const RateRow = ({ rate, firstActiveRateId = '' }) => (
  <div
    className={classnames(style.rate, {
      [style.disabled]: !rate.isIncluded,
    })}
  >
    <div className={style['rate-info-block']}>
      <div className={style['radio-button-wrapper']}>
        <RadioCheckListItem key={rate.optionId} isChecked={firstActiveRateId === rate.optionId} isDisabled={!rate.isIncluded} />
      </div>
      <div className={style['rate-info']}>
        <div className={style['rate-name']}>{rate.name}</div>
        <div className={style['rate-description']}>{rate.description}</div>
      </div>
    </div>
    <div className={style['delivery-estimate-info']}>
      <div className={style['rate-delivery-time']}>{getDeliveryTimeStringFromRate(rate)}</div>
      {(rate.maxDeliveryDate || rate.minDeliveryDate) && (
        <div className={style['rate-description']}>
          <FormattedMessage {...messages.estimatedTransitTime} />
        </div>
      )}
    </div>
    <RateStatusIndicator rate={rate} />
    <div className={style['rate-price']}>
      <FormattedCurrencyContainer currencyCode={rate.cost.code} value={rate.cost.value} />
    </div>
  </div>
);

RateRow.propTypes = {
  rate: PropTypes.shape({
    optionId: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    maxDeliveryDate: PropTypes.string,
    minDeliveryDate: PropTypes.string,
    isIncluded: PropTypes.bool,
    cost: PropTypes.shape({
      code: PropTypes.string,
      value: PropTypes.number,
    }),
  }).isRequired,
  firstActiveRateId: PropTypes.string,
};
